import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="progress-demo"
export default class extends Controller {
  static targets = ["progress", "completion", "step1", "step2", "step3"]
  static values = { status: { type: String, default: "queued" } }

  connect() {
    this.updateDisplay()
  }

  setStatus(event) {
    this.statusValue = event.currentTarget.dataset.status
  }

  statusValueChanged() {
    this.updateDisplay()
  }

  updateDisplay() {
    const status = this.statusValue

    this.progressTarget.classList.toggle("hidden", status === "sent")
    this.completionTarget.classList.toggle("hidden", status !== "sent")

    // Update progress bar data-status
    this.progressTarget.dataset.status = status

    // Calculate step states
    const stepStates = this.calculateStepStates(status)

    // Update step classes
    this.updateStepClass(this.step1Target, stepStates[0])
    this.updateStepClass(this.step2Target, stepStates[1])
    this.updateStepClass(this.step3Target, stepStates[2])
  }

  calculateStepStates(status) {
    switch (status) {
      case "queued":
        return ["active", "pending", "pending"]
      case "extracting":
        return ["completed", "active", "pending"]
      case "sending":
        return ["completed", "completed", "active"]
      case "sent":
        return ["completed", "completed", "completed"]
      default:
        return ["pending", "pending", "pending"]
    }
  }

  updateStepClass(element, state) {
    // Remove all state classes
    element.classList.remove(
      "upload-progress__step--pending",
      "upload-progress__step--active",
      "upload-progress__step--completed"
    )
    // Add new state class
    element.classList.add(`upload-progress__step--${state}`)
  }
}
